import { render, staticRenderFns } from "./IncidentDetails.vue?vue&type=template&id=8fb54410&scoped=true&"
import script from "./IncidentDetails.vue?vue&type=script&lang=ts&"
export * from "./IncidentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./IncidentDetails.vue?vue&type=style&index=0&id=8fb54410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb54410",
  null
  
)

export default component.exports